import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { operationTypesInversed, OperationTypesKeys } from '@teinor/erp/types/company/cashRegister/cashRegisterMoney/cashRegisterMoneyLog'
import { useCallback, useState } from 'react'
import { DisplayPriceGettingParams } from '../../../../../../../baseComponents/Displays/DisplayPrice'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { dictIcon } from '../../../../../../../utils/icons'
import { PaymentTypeModelTypeExtendedTPV } from '../../../types'
import CustomInputTotalsTablePriceTPV from '../../CustomInputTotalsTable'

interface PaymentMethodBoxTPVProps {
    element: PaymentTypeModelTypeExtendedTPV
    CurrencyId: string
    total: number
}

const PaymentMethodBoxTPV: React.FC<PaymentMethodBoxTPVProps> = ({ element, CurrencyId, total }) => {
    const { showInfo, handleShowInfo } = usePaymentMethodBoxTPVLogic()
    return (
        <div className='py-15 px-30 border payment_box flex flex-col w-full border-gray-D6 '>
            <div className='flex w-full'>
                <div className='flex flex-auto items-center'>
                    <TwinIcon icon={dictIcon[element.icon || 'faMoneyBill']} className='mr-8 regular20 flex w-24 h-24 text-gray-63 ' />
                    <span className='regular16'>
                        {element.name}
                    </span>
                </div>
                <DisplayPriceGettingParams CurrencyId={CurrencyId} value={total} with_vat={false} />
                <div className='ml-10 cursor-pointer' onClick={handleShowInfo}>
                    <TwinIcon icon={showInfo ? faChevronUp : faChevronDown} />
                </div>
            </div>
            {showInfo ? <PaymentMethodBoxInfo element={element} CurrencyId={CurrencyId} /> : null}
        </div>
    )
}

const usePaymentMethodBoxTPVLogic = () => {
    const [showInfo, setShowInfo] = useState<boolean>(false)
    const handleShowInfo = useCallback(() => {
        setShowInfo((old) => { return !old })
    }, [setShowInfo])
    return { showInfo, handleShowInfo }
}

interface PaymentMethodBoxInfoProps {
    element: PaymentTypeModelTypeExtendedTPV
    CurrencyId: string
}

const PaymentMethodBoxInfo: React.FC<PaymentMethodBoxInfoProps> = ({ element, CurrencyId }) => {
    const { t } = useTwinTranslation()
    const dictTotalsByOperationType: Record<OperationTypesKeys, TwinDictionary> = {
        0: { title: t('cashOpening', 'Apertura de caja'), total: 0},
        1: { title: t('cashClosing', 'Cierre de caja'), total: 0 },
        2: { title: t('totalSells', 'Total ventas'), total: 0 },
        3: { title: t('totalRefunds', 'Total devoluciones'), total: 0 },
        4: { title: t('cashIns', 'Entradas de caja'), total: 0 },
        5: { title: t('cashOuts', 'Salidas de caja'), total: 0 },
        6: { title: t('regularization', 'Regularización'), total: 0 },
    }
    const renderThis: JSX.Element[] = []
    for (const log of element?.CashRegisterMoney?.CashRegisterMoneyLogs || []) {
        let myTotal = dictTotalsByOperationType[log.operationType as OperationTypesKeys].total + parseFloat(String(log.money))
        if (log.operationType === operationTypesInversed['cashOpening']) {
            myTotal = dictTotalsByOperationType[log.operationType as OperationTypesKeys].total + parseFloat(String(log.endMoney))
        }
        dictTotalsByOperationType[log.operationType as OperationTypesKeys].total = myTotal
    }
    for (const key in dictTotalsByOperationType) {
        if (parseInt(key) !== operationTypesInversed['cashClosing']) {
            const myType = dictTotalsByOperationType[parseInt(key) as OperationTypesKeys ]
            renderThis.push(<CustomInputTotalsTablePriceTPV currency={CurrencyId} value={parseFloat(String(myType.total))} className='regular16 ' classNameValue={'regular16 '} inputName={myType.title} key={key} />)
        }
    }
    return (
        <div className=' border-t border-gray-D6 flex flex-col w-full mt-15 pt-10'>
            {renderThis}
        </div>
    )
}


export default PaymentMethodBoxTPV